var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import * as Cookies from 'js-cookie';
import CombinedCookie from './combinedCookie';
import CookieSerializerFunnel from './cookieSerializerFunnel';
import DataLayer from '../utilities/dataLayerSynchronous';
export const name = 'CookieService';
var Cookie;
(function (Cookie) {
    Cookie["Persistent"] = "sd_p";
    Cookie["Session"] = "sd_s";
})(Cookie || (Cookie = {}));
var CookieExpiration;
(function (CookieExpiration) {
    CookieExpiration[CookieExpiration["OneYear"] = 365] = "OneYear";
})(CookieExpiration || (CookieExpiration = {}));
let CookieService = class CookieService {
    constructor() {
        /** Setup cookie handler for raw converting of reads and writes for compatibility with sd.cookies cookies */
        this.cookieHandler = Cookies.withConverter({
            read: (value) => value,
            write: (value) => value,
        });
        const traffic = DataLayer.get('traffic');
        this.domain = traffic.cookieDomain ?? `.${window.location.hostname}`;
    }
    /**
     * Get persistent cookie
     */
    getPersistent() {
        if (!this.persistentCookie) {
            this.persistentCookie = new CombinedCookie(this.cookieHandler, {
                name: Cookie.Persistent,
                attributes: {
                    expires: CookieExpiration.OneYear,
                    domain: this.domain,
                },
            });
        }
        return this.persistentCookie;
    }
    /**
     * Get Session cookie
     */
    getSession() {
        if (!this.sessionCookie) {
            this.sessionCookie = new CombinedCookie(this.cookieHandler, {
                name: Cookie.Session,
                serializers: {
                    funnel: new CookieSerializerFunnel(),
                },
                attributes: {
                    domain: this.domain,
                },
            });
        }
        return this.sessionCookie;
    }
    // Returns a simple cookie
    getCookie(cookieName) {
        return {
            name: cookieName,
            value: this.cookieHandler.get(cookieName),
        };
    }
    // Stores a simple cookie
    setCookie(cookie) {
        if (typeof cookie.value === 'string') {
            this.cookieHandler.set(cookie.name, cookie.value, {
                domain: this.domain,
            });
        }
    }
};
CookieService = __decorate([
    injectable(name)
], CookieService);
export default CookieService;
